// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveDistrictDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import DistrictDTO from '../models/DistrictDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    districtId: string | null | null;
    district: DistrictDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            districtId: null,
            district: null,
        },
        initValues);
    },
    districtId: 'districtId',
    district: 'district',
}

interface Result extends ResultDTO {
    district: DistrictDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            district: null,
        },
        initValues);
    },
    district: 'district',
}

export { Request, Result };